/** Product copy for the free audio-to-text download surface. */
export const FREE_AUDIO_TO_TEXT_WATERMARK = 'Transcribed with Wisprs - Free Audio-to-Text';

